import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import KokUygulama from './KokUygulama';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <KokUygulama />
  </AuthProvider>
);
